import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#f50057' },
    background: { default: '#f8fafc', paper: '#fff' },
    text: { primary: '#222', secondary: '#555' },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h4: { fontWeight: 700 },
    subtitle1: { color: '#555' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 600 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 12, boxShadow: '0 2px 8px 0 rgba(60,60,60,0.04)' },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: { borderRadius: 12, background: '#fff' },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { fontSize: 15 },
        head: { fontWeight: 700, background: '#f5f7fa' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
  },
});

export default theme;
